import { EnvProvider } from '@zenbusiness/application-commons-env';

import ClickstreamWrapper from '#client/ClickstreamWrapper';
import AppWrapper from '#client/Providers';
import { FederatedAppRoutesV2 } from '#client/routes';

const ENV = process.env.BUILD_ENV;

function FederatedAppV2() {
  return (
    <EnvProvider env={ENV}>
      <EnvProvider env={`${ENV.DEFAULT_SEGMENT}/env?v=${ENV.RELEASE_VERSION}`}>
        <AppWrapper federated>
          <ClickstreamWrapper>
            <FederatedAppRoutesV2 />
          </ClickstreamWrapper>
        </AppWrapper>
      </EnvProvider>
    </EnvProvider>
  );
}

export default FederatedAppV2;
